import { useMutation } from "@tanstack/react-query";
import { objNamesToSnakeCase } from "common/utils/helpers/cases";
import { api, type models } from "jiffy-api";

export function useDftUploadArtwork() {
  return useMutation({
    retry: (failureCount, error) => {
      const errorData = (error as any)?.response?.data;
      const isValidationError =
        errorData?.error_type === "backend_file_validation" || errorData?.validation_error;

      if (isValidationError) {
        return false;
      }

      return failureCount < 2;
    },
    networkMode: "always", // Always attempt the mutation even when offline, causing it to fail and trigger retries
    mutationFn: async (params: models.dtf.uploadArtwork.Request) => {
      const formData = new FormData();
      const fields = objNamesToSnakeCase(params);

      for (const [key, value] of Object.entries(fields)) {
        if (key === "file") {
          formData.append(key, params.file);
        } else {
          formData.append(key, value);
        }
      }

      return api.dtf.uploadArtwork(formData, {
        raw: true,
        useAxiosForRequest: true,
        headers: { "Content-Type": undefined }
      });
    }
  });
}
